// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot-page .forgot-title {
    margin-bottom: 20px !important;
}

.forgot-page .forgot-submit {
    width: 100% !important;
    min-width: 100%;
    margin-top: 6px !important;
}

.forgot-page .validation-error-green {
    margin-bottom: 10px;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/forgot/forgotComponent.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB","sourcesContent":[".forgot-page .forgot-title {\r\n    margin-bottom: 20px !important;\r\n}\r\n\r\n.forgot-page .forgot-submit {\r\n    width: 100% !important;\r\n    min-width: 100%;\r\n    margin-top: 6px !important;\r\n}\r\n\r\n.forgot-page .validation-error-green {\r\n    margin-bottom: 10px;\r\n    text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
